import { useQuery } from "@tanstack/react-query";
import { useAxiosWithAuth } from "Hooks/useAxiosWithAuth";


export const useClientAds = () => {
    const api = useAxiosWithAuth();

    const getData = async () => {
        const { data } = await api.get('user/advertisements');
        return data;
    };

    return useQuery({
        refetchOnWindowFocus: false,
        queryKey: ['client-ads'],
        queryFn: getData,
        retry: false,
    });
};

export const usePrices = () => {
    const api = useAxiosWithAuth('https://exchange.smartex-sy.com/currency');

    const getData = async () => {
        const { data } = await api.get();
        return data;
    };

    return useQuery({
        refetchOnWindowFocus: false,
        queryKey: ['prices'],
        queryFn: getData,
        retry: false,
    });
};
